import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import SpText from "../../components/atoms/SpText";
import CloseIcon from "@material-ui/icons/Close";
import SpIconButton from "./SpIconButton";
import { styled } from "../styled";
import { theme } from "../theme";

const StyledRow = styled("div")({
	display: "flex",
	flex: "1",
	paddingLeft: "2%",
	paddingRight: "2%",
	paddingTop: "2%",
	paddingBottom: "2%",
	justifyContent: "space-between",
});

const useStyles = makeStyles({
	paper: {
		borderRadius: 20,
		color: "#4DAC27",
		borderColor: "#4DAC27",
		backgroundColor: "#FFF",
		boxShadow: ` 5px 5px 10px ${theme.colors.mainGreen.secondary} `,
	},
});

const SpDialog = ({ children, open, setOpen, onCloseFunctions, title, variant }) => {
	const classes = useStyles();

	const handleClose = () => {
		setOpen(false);
		if (onCloseFunctions) {
			onCloseFunctions();
		}
	};

	return (
		<Dialog classes={classes} open={open} fullWidth maxWidth='md' onClose={handleClose}>
			<StyledRow>
				<SpText variant='h1PageTitleDialog'>{title}</SpText>
				<SpIconButton alignSelf='flex-end' color={theme.colors.mainGreen.main} variant={variant ? variant : "lightBlue"} onClick={handleClose} small>
					<CloseIcon />
				</SpIconButton>
			</StyledRow>
			<DialogContent>{children}</DialogContent>
		</Dialog>
	);
};

export default SpDialog;
